import { motion } from 'framer-motion';
import { siteConfig } from '../data/siteData';

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 bg-brand-accent">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl md:text-6xl font-bold text-brand-primary mb-6">
              Privacy Policy
            </h1>
            <p className="text-slate-600 text-lg">Last updated: January 2024</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Introduction
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              {siteConfig.name} ("we," "us," or "our") respects your privacy and is committed to
              protecting your personal data. This privacy policy explains how we collect, use, and
              safeguard your information when you visit our website.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Information We Collect
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We may collect the following types of information:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>
                <strong>Personal Information:</strong> Name, email address, and other information
                you provide through contact forms.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you use our website, including
                pages visited and time spent on the site.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, browser type, device information, and
                cookies.
              </li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              How We Use Your Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We use the information we collect for the following purposes:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>To respond to your inquiries and requests</li>
              <li>To provide and improve our services</li>
              <li>To send newsletters and updates (with your consent)</li>
              <li>To analyze website usage and improve user experience</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Cookies
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We use cookies and similar tracking technologies to enhance your browsing experience.
              You can control cookies through your browser settings. Please note that disabling
              cookies may affect the functionality of certain features on our website.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Data Sharing
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We do not sell your personal information. We may share your data with trusted service
              providers who assist us in operating our website and conducting business, subject to
              confidentiality agreements.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Data Security
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We implement appropriate technical and organizational measures to protect your
              personal data against unauthorized access, alteration, disclosure, or destruction.
              However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Your Rights
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Right to access your personal data</li>
              <li>Right to rectify inaccurate data</li>
              <li>Right to erasure ("right to be forgotten")</li>
              <li>Right to restrict processing</li>
              <li>Right to data portability</li>
              <li>Right to object to processing</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Third-Party Links
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Our website may contain links to third-party websites. We are not responsible for the
              privacy practices of these external sites. We encourage you to review their privacy
              policies.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Changes to This Policy
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We may update this privacy policy from time to time. Any changes will be posted on
              this page with an updated revision date.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-primary mt-8 mb-4">
              Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              If you have any questions about this privacy policy or our data practices, please
              contact us through the contact form on this website.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
